import { get } from "lodash";
export default function getCodeFromError(err) {
    // if there is a config property, it was probably an axios request
    var fallback = err.config ? "Network Error" : "";
    return (attemptToGetCode(err) || fallback // we have no idea
    );
}
/**
 * @description: low level functionality to find a potential error code,
 * you should probably use `getCodeFromError()` instead
 */
export function attemptToGetCode(err) {
    return (err.code || // simple assign
        err.errorCode || // graph response
        get(err, "response.data.code") || // REST API response
        get(err, "data.errors[0].errorCode") || //  apollo client raw error
        get(err, "data.response.errors[0].errorCode") || // apollo client error
        get(err, "networkError.response") || // low level apollo error
        get(err, "graphQLErrors[0].errorCode") || // mid level apollo error
        undefined);
}
